<template>
    <div>
        <NavigationControl class="pt-2" :link="link" />
        <div class="mt-5">
            <Card class="max-width mx-auto">
                <template #header><h4 v-if="!loading" class="text-uppercase text-center mb-0">{{ loadedTopic.translation ? loadedTopic.translation.title : ''}}</h4></template>
                <loading-spinner v-if="loading" />
                <template v-else>
                    <h4 class="text-center mb-3">{{ loadedTopic.translation ? loadedTopic.translation.description : ''}}</h4>
                    <submit-success view v-if="loadedTopic.answered" />
                    <template v-else-if="showResult">
                        <base-progress
                            v-for="option in loadedTopic.options"
                            :key="option.id"
                            show-label
                            type="success"
                            :height="8"
                            :value="checkTotalPercent(loadedTopic.total, option.selections)"
                            :label="option.translation.name"></base-progress>
                    </template>
                    <template v-else>
                        <form role="form">
                            <div
                                v-if="loadedTopic.type !== 4"  
                                class="control ml-4 mb-4">
                                <div
                                    v-for="(option, i) in loadedTopic.options"
                                    :key="option.id"
                                    class="mt-2 custom-control custom-radio">
                                    <div>
                                        <input type="radio" v-model="answer" :value="option.translation.option_id" :id="option.translation.option_id" :name="`survey-option-${i}`" class="custom-control-input">
                                        <label class="custom-control-label" :for="option.translation.option_id">
                                            <span v-html="optionLabel(loadedTopic.type, option.translation.slug, option.translation.name, option.icon)"></span>
                                        </label>
                                    </div>
                                </div>
                            </div>
                            <TopicSatisfactionGrade 
                                v-else-if="loadedTopic.type === 4"
                                :topic="loadedTopic"
                                v-model="answer"
                            />
                            <base-input
                                v-if="loadedTopic.justify_answer"
                                :label="$t('common.justify_answer')"
                                :error="errors.first($t('common.justify_answer'))">
                                <textarea v-validate="'required|min:6'" v-model="justify" :name="$t('common.justify_answer')" class="form-control" id="exampleFormControlTextarea3" rows="2"></textarea>
                            </base-input>
                        </form>
                    </template>
                </template>
                <template #footer>
                    <div class="w-100 d-flex justify-content-between">
                        <base-button
                            v-if="!loadedTopic.answered && !submited"
                            type="primary"
                            @click="submitAnswer">{{$t('common.send')}}</base-button>
                    </div>
                </template>
            </Card>
        </div>
    </div>
</template>

<script>
import NavigationControl from '../components/Common/NavigationControl'
import LoadingSpinner from '../components/Common/LoadingSpinner'
import SubmitSuccess from '../components/Common/SubmitSuccess'

import BaseModal from '../argon/components/Modal';
import BaseButton from '../argon/components/BaseButton';
import BaseProgress from '../argon/components/BaseProgress'
import BaseInput from '../argon/components/Inputs/BaseInput'
import Card from '../argon/components/Cards/Card'

import TopicSatisfactionGrade from './Common/TopicComponents/TopicSatisfactionGrade';

export default {
    name: 'Topic',
    components: {
        BaseModal,
        BaseButton,
        LoadingSpinner,
        SubmitSuccess,
        BaseProgress,
        BaseInput,
        NavigationControl,
        Card,
        TopicSatisfactionGrade
    },
    props: {
        parents: Object,
        topicId: Number
    },
    data() {
        return {
            loadedTopic: {},
            modal: true,
            loading: false,
            submited: false,
            showResult: false,
            justify: '',
            answer: '',
        }
    },
    watch: {
        topic(value, oldValue) {
            if (value !== oldValue) {
                this.loadedTopic = value
            }
        }
    },
    computed: {
        color() {
            return this.$store.getters.COLOR
        },
        link() {
            return this.$store.getters.LOADED_CONTENT_LINKS
        },
        submodules() {
            const submodules = new URLSearchParams(window.location.search);
            return submodules.getAll("submodules[]");
        },
    },

    methods: {
        loadTopic() {
            this.loading = true
            window.axios
                .get(`/api/app/topic/${this.parents.topicId}`)
                .then(res => this.loadedTopic = res.data.data)
                .catch(err => console.error(err))
                .finally(() => {
                    this.loading = false
                })
        },
        optionLabel(type, slug, name, icon) {
            let count = slug[0]
            let starRating = `<i class="survey-star-rating mdi mdi-star"></i>`
            switch (type) {
                case 1:
                    return name
                    break;
                case 2:
                    if (count == 1) return starRating.repeat(count)
                    if (count == 2) return starRating.repeat(count)
                    if (count == 3) return starRating.repeat(count)
                    if (count == 4) return starRating.repeat(count)
                    if (count == 5) return starRating.repeat(count)
                    break;
                case 3:
                    if (icon == 5) return `<i class="nch-topic-rating mdi mdi-emoticon-angry-outline"></i><span class="nch-topic-rating--text">${name}</span>`
                    if (icon == 4) return `<i class="nch-topic-rating mdi mdi-emoticon-sad-outline"></i><span class="nch-topic-rating--text">${name}</span>`
                    if (icon == 3) return `<i class="nch-topic-rating mdi mdi-emoticon-neutral-outline"></i><span class="nch-topic-rating--text">${name}</span>`
                    if (icon == 2) return `<i class="nch-topic-rating mdi mdi-emoticon-happy-outline"></i><span class="nch-topic-rating--text">${name}</span>`
                    if (icon == 1) return `<i class="nch-topic-rating mdi mdi-emoticon-excited-outline"></i><span class="nch-topic-rating--text">${name}</span>`
                    break;

                default:
                    break;
            }
        },
        submitAnswer() {
            if (!this.answer) {
                this.$notify({
                    type: 'danger',
                    message: this.$t('common.select_one')
                })
                return;
            }
            this.$validator.validate()
                .then(async valid => {
                    if (valid) {

                        this.loading = true
                        await axios.post(`/api/app/topic/${this.loadedTopic.id}/answer/${this.answer}`, {
                                justify: this.justify,
                                parents: this.parents,
                            })
                            .then(res => {
                                this.loadedTopic = res.data.data
                                this.showResult = true
                                this.submited = true
                                this.$emit('submited')
                            })
                            .catch(err => {
                                console.error(err)
                                this.showResult = false
                            })
                            .finally(() => {
                                this.loading = false
                            })

                    }
                })

        },
        checkTotalPercent(total, selections) {
            const res = selections / total * 100
            return Math.round((res + Number.EPSILON) * 100) / 100
        },
        getLinks() {
            this.$store.dispatch("LOAD_LINKS", {
                parents: this.parents,
                submodules: this.submodules
            })
        }
    },
    mounted() {
        this.getLinks();
        this.loadTopic();
    }

}
</script>

<style>
.survey-star-rating {
    color: #e6e61a;
    font-size: 1.2rem
}

.nch-topic-rating {
    font-size: 1.7rem;
    position: absolute;
    top: -10px;
}

.nch-topic-rating--text {
    font-size: .9rem;
    margin-left: 2.7rem;
}

.max-width {
    max-width: 700px;
}
</style>
